import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";
 

function ModalRecuperarContra() {

    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [mostrarCambio, setMostrarCambio] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const[input, setInput] = useState ({
        usuario: "",
        email: "",
        token: "",
        contraseña: ""
    });
    
    function handleChange(event){
        const {name, value} = event.target;
        // guardar el valor previo.
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        });
    }

    async function handleClick(event){
        event.preventDefault();
        await enviarToken();
    }

    async function cambiarContra(event){
        event.preventDefault();

        try{
            const resCambio = await axios.post("/recuperar-contrasena", {
                username: input.usuario,
                email: input.email,
                token: input.token,
                password: input.contraseña
            });

            if(resCambio.data.status === 200){
                await Swal.fire({
                    icon: "success",
                    title: "Contraseña modificada",
                    text: "La contraseña ha sido cambiada correctamente. Por favor vuelve a iniciar sesión.",
                    confirmButtonText: "Aceptar"
                });
                handleClose();
                navigate("/iniciar-sesion");
            }
            else{
                await Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: resCambio.data.mensaje,
                    confirmButtonText: "Aceptar"
                });
            }
        }
        catch(err){
            console.log("error al recuperar contraseña.", err);
            await Swal.fire({
                icon: "error",
                title: "Error al cambiar la contraseña",
                text: "No fue posible cambiar la contraseña.",
                confirmButtonText: "Aceptar"
            });
        }
    }

    async function enviarToken(){
        try{
            const resEnviar = await axios.post("/enviar-token-recuperar-contrasena", {
                username: input.usuario,
                email: input.email
            });

            if(resEnviar.data.status === 200){
                setMostrarCambio(true);
                await Swal.fire({
                    icon: "success",
                    title: "Token enviado",
                    text: resEnviar.data.mensaje,
                    confirmButtonText: "Aceptar"
                });
            }
            else{
                await Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: resEnviar.data.mensaje,
                    confirmButtonText: "Aceptar"
                });
            }
        }
        catch(er){
            console.log("error al enviar correo de token.", er);
            await Swal.fire({
                icon: "error",
                title: "Error al enviar el token",
                text: "No fue posible enviar el token al correo.",
                confirmButtonText: "Aceptar"
            });
        }
    }




    return(
    <div>
        <span
            onClick={handleShow}
            style={{ cursor: "pointer", color: "var(--gris-claro-medio)" }}
        >
            Recuperar contraseña
        </span>

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Recuperar contraseña</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <p className="mb-4 text-muted">
                        Enviaremos un token a tu correo para que modifiques tu contraseña. Llena el usuario y el email para enviarlo. Luego ingresa el token en el campo para cambiar la contraseña.
                    </p>
                    <main >
                        <form> 
                            {/* usuario */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold text-dark">Usuario</label>
                                <input
                                    onChange={handleChange}
                                    value={input.usuario}
                                    name="usuario"
                                    type="text"
                                    className="form-control form-control-lg rounded-4"
                                    placeholder="Ingresa tu usuario"
                                />
                            </div>

                            {/* email */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold text-dark">Email</label>
                                <input
                                    onChange={handleChange}
                                    value={input.email}
                                    name="email"
                                    type="text"
                                    className="form-control form-control-lg rounded-4"
                                    placeholder="Ingresa tu correo"
                                />
                            </div>

                            {mostrarCambio && (
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-dark">Token</label>
                                    <input
                                        onChange={handleChange}
                                        value={input.token}
                                        name="token"
                                        type="text"
                                        className="form-control form-control-lg rounded-4"
                                        placeholder="Ingresa el código enviado a tu correo"
                                    />
                                </div>
                            )}

                            {mostrarCambio && (
                                <div className="mb-4">
                                    <label className="form-label fw-semibold text-dark">Nueva contraseña</label>
                                    <input
                                        onChange={handleChange}
                                        value={input.contraseña}
                                        name="contraseña"
                                        type="password"
                                        className="form-control form-control-lg rounded-4"
                                        placeholder="Ingresa tu nueva contraseña"
                                    />
                                </div>
                            )}

                            <div className="d-flex justify-content-center gap-2 flex-wrap">
                                {!mostrarCambio ? (
                                    <button onClick={handleClick} className="btn btn-primary px-4 py-2 fw-semibold" type="submit">Enviar token</button>
                                ) : (
                                    <button onClick={cambiarContra} className="btn btn-primary px-4 py-2 fw-semibold" type="submit">Cambiar contraseña</button>
                                )}
                            </div>
                        </form>
                    </main>
                </div>
            </Modal.Body>
        </Modal>
    </div>
    )
}



export default ModalRecuperarContra;